import { Card } from './components/Card';
import { Text } from './components/Text';
import { DataTable } from './components/DataTable';
import { Heading } from './components/Heading';
import { Divider } from './components/Divider';

export const portalComponentRegistry = {
  Card,
  Text,
  DataTable,
  Heading,
  Divider,
};
